import {fork, call, take, put} from 'redux-saga/effects'
import {CALENDAR_CHANGE_DATE} from 'actions/calendar/constants'
import {setDate} from 'actions/calendar'
import {updateFilteredDate} from 'sagas/api/update-filtered-date'
import moment from 'moment'

export function * changeDateFlow () {
  while (true) {
    let request = yield take(CALENDAR_CHANGE_DATE)
    let {startDate, endDate} = request.payload
    let data = yield call(updateFilteredDate, {from: startDate.toString(), to: endDate.startOf('day').toString()})
    if (data) {
      yield put(setDate(moment(data.start_date), moment(data.end_date)))
    }
  }
}

export default function * calendarSaga () {
  yield fork(changeDateFlow)
}



// WEBPACK FOOTER //
// ./app/sagas/calendar.js